import "./time-range-select-dropdown.scss";

import { MenuItem, Select } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import * as React from "react";
import { dayMs, hourMs, minuteMs } from "verdi-common/timeConstants";

const TIME_RANGE_DEFINITIONS = [
    { name: "1 hour", range: hourMs, buffer: minuteMs * 10 },
    { name: "Day", range: dayMs, buffer: hourMs },
    { name: "4 days", range: dayMs * 4, buffer: hourMs * 4 },
    { name: "Week", range: dayMs * 7, buffer: hourMs * 12 },
    { name: "Month", range: dayMs * 30, buffer: dayMs },
    { name: "3 months", range: dayMs * 91, buffer: dayMs },
];

export const makeStaticZoneGraphTimeRanges = () => {
    const now = Date.now();
    return TIME_RANGE_DEFINITIONS.map(({ name, range, buffer }) => ({
        name,
        startTime: new Date(now - range + buffer),
        endTime: new Date(now + buffer),
    }));
};

export default function TimeRangeSelectDropdown({ defaultTimeRange, onChange }) {
    const [timeRange, setTimeRange] = React.useState(defaultTimeRange);

    return (
        <FormControl className={"StaticZoneGraphTimeRangeDropdown"} size={"small"}>
            <Select
                className={"StaticZoneGraphTimeRangeSelect"}
                value={timeRange}
                onChange={(e) => {
                    const freshOptions = makeStaticZoneGraphTimeRanges();
                    if (onChange) {
                        const selected = freshOptions.find((o) => o.name === e.target.value);
                        if (selected) {
                            onChange(selected.startTime, selected.endTime);
                        }
                    }
                    setTimeRange(e.target.value);
                }}
            >
                {makeStaticZoneGraphTimeRanges().map((range) => (
                    <MenuItem value={range.name} key={range.name}>
                        {range.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
